// routes/_terms.privacy.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_terms.privacy')

export const handle = { name: 'privacy' }

export default dynamic(getClientModule, { ssr: false })
